import {
	AfterViewInit,
	Component,
	Input,
	OnChanges,
	SimpleChanges
} from '@angular/core';
import { PieChartData, PieOptions } from '@models/models';
import { PieGraphService } from '@web-services/graph/pie-graph.service';

@Component({
	selector: 'lead-sources-graph',
	template: require('./lead-sources-graph.component.html'),
	styles: [require('./lead-sources-graph.component.scss')]
})
export class LeadSourcesGraphComponent implements AfterViewInit, OnChanges {
	@Input() chartData: PieChartData;
	@Input() chartID = 'pie-chart';
	@Input() customOptions: PieOptions;
	constructor(private graphService: PieGraphService) {}

	ngAfterViewInit(): void {
		this.graphService.drawPieChart(
			this.chartData,
			this.chartID,
			this.customOptions
		);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes.chartData &&
			!changes.chartData.isFirstChange() &&
			changes.chartData.currentValue
		) {
			this.graphService.drawPieChart(
				this.chartData,
				this.chartID,
				this.customOptions
			);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/dashboard/graphs-block/lead-sources-graph/lead-sources-graph.component.ts